<p-dialog [visible]="visible" [modal]="true" [blockScroll]="true" [draggable]="false" [resizable]="false" [closable]="false" [closeOnEscape]="false" [dismissableMask]="false" styleClass="digital-card-passcode-dialog">

  <form [formGroup]="passcodeForm" (ngSubmit)="onSubmitPasscode()" [attr.aria-busy]="loading">
    <h3 class="antialiased text-center mt-1 mb-3">{{ 'DIGITAL_PASSPORT.PASSCODE.TITLE' | translate }}</h3>
    <p class="text-sm mb-4 text-center">{{ 'DIGITAL_PASSPORT.PASSCODE.MESSAGE' | translate }}</p>

    <div class="row">
      <div class="field-wr col-12">
        <!-- <label for="digital-passport-security-passcode" class="block text-sm mb-1">
          {{ 'DIGITAL_PASSPORT.PASSCODE.LABEL' | translate }}
          <i class="icon-required-field"></i>
        </label> -->

        <input id="digital-passport-security-passcode" data-testid="digital-passport-security-passcode" class="text-field mt-2" type="text" formControlName="securityPasscode" autocomplete="off" autocapitalize="off" [spellcheck]="false" [readonly]="loading">

        <!-- @if ( passcodeForm.controls['securityPasscode'].touched && passcodeForm.controls['securityPasscode'].hasError('required')) {
          <small class="block mt-1">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
        } -->
      </div>
    </div>

    @if (errorMessage) {
      <p data-testid="digital-passport-passcode-error" class="p-error text-sm text-center mt-1 mb-7">{{ errorMessage }}</p>
    }

    <div class="flex justify-center mt-1 mb-2">
      <button data-testid="digital-passport-verify-passcode" type="submit" class="btn primary-btn" [disabled]="passcodeForm.invalid || loading">
        {{ 'DIGITAL_PASSPORT.PASSCODE.BTN_VERIFY' | translate }}
      </button>
    </div>
  </form>
</p-dialog>
